const isProdEnvironment = (): boolean => process.env.NODE_ENV?.toLowerCase() === 'production';

export default isProdEnvironment;
